module.exports = __webpack_public_path__ + "media/images/appIcon-1d4596343b100fd337d92c2efbbef0b5.png";